import { render, staticRenderFns } from "./ConfirmTraining.vue?vue&type=template&id=56f7770f&scoped=true"
import script from "./ConfirmTraining.vue?vue&type=script&lang=js"
export * from "./ConfirmTraining.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTraining.vue?vue&type=style&index=0&id=56f7770f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7770f",
  null
  
)

export default component.exports